import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import LanguageSelect from './pages/visitor/LanguageSelect';
import CodeEntry from './pages/visitor/CodeEntry';
import QRInstructions from './pages/visitor/QRInstructions';
import NewQRInstructions from './pages/visitor/New';
import ExhibitDetail from './pages/visitor/ExhibitDetail';
import ZoneDetail from './pages/visitor/ZoneDetail';
import History from './pages/visitor/History';
import StaffLogin from './pages/staff/StaffLogin';
import StaffDashboard from './pages/staff/StaffDashboard';
import ExhibitForm from './pages/staff/ExhibitForm';
import ZoneDashboard from './pages/staff/ZoneDashboard';
import ZoneForm from './pages/staff/ZoneForm';
import ChangePassword from './pages/staff/ChangePassword';
import VisitorStatistics from './pages/staff/VisitorStatistics';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {/* Visitor Routes */}
            <Route path="/" element={<LanguageSelect />} />
            <Route path="/code-entry" element={<CodeEntry />} />
            <Route path="/qr-instructions" element={<NewQRInstructions />} />
            {/* <Route path="/new" element={<NewQRInstructions />} /> */}
            <Route path="/exhibit/:id" element={<ExhibitDetail />} />
            <Route path="/zone/:id" element={<ZoneDetail />} />
            <Route path="/history" element={<History />} />

            {/* Staff Routes */}
            <Route path="/staff/login" element={<StaffLogin />} />
            <Route path="/staff/dashboard" element={<ProtectedRoute><StaffDashboard /></ProtectedRoute>} />
            <Route path="/staff/exhibit/create" element={<ProtectedRoute><ExhibitForm /></ProtectedRoute>} />
            <Route path="/staff/exhibit/:id/edit" element={<ProtectedRoute><ExhibitForm /></ProtectedRoute>} />
            <Route path="/staff/zones" element={<ProtectedRoute><ZoneDashboard /></ProtectedRoute>} />
            <Route path="/staff/zone/create" element={<ProtectedRoute><ZoneForm /></ProtectedRoute>} />
            <Route path="/staff/zone/:id/edit" element={<ProtectedRoute><ZoneForm /></ProtectedRoute>} />
            <Route path="/staff/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="/staff/statistics" element={<ProtectedRoute><VisitorStatistics /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
